<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 md6>
        <h3>Assignés</h3>
        <v-list>
          <template v-for="item in assignees">
            <FormLine
              :item="item"
              v-model="prospect.assignees"
              :key="item.name"
              :edit-mode="editMode"
            ></FormLine>
            <v-divider :key="`divider-${item.name}`" />
          </template>
        </v-list>
      </v-flex>
      <v-flex xs12 md6>
        <h3>Règlements du prescripteur</h3>
        <FormLine :item="rewards" v-model="prospect" :edit-mode="editMode" />
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-2">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn color="red" v-on="on"
            >Supprimer définitivement le prospect</v-btn
          >
        </template>
        <v-list>
          <v-list-tile>
            <v-list-tile-title>Etes vous sûr ? </v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-title @click="deleteProspect()">Oui</v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-title>Non</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-layout>
  </div>
</template>

<script>
import FormLine from "../commons/FormLine.vue";
import { mapState } from "vuex";
import { fetchHil } from "../../utils";

export default {
  props: ["prospect", "editMode"],
  components: { FormLine },
  inject: ["$validator"],
  data() {
    return {
      rewards: {
        name: "rewards.sentToAL",
        label: "Montant",
        as: "number"
      },
      assignees: [
        {
          name: "lead",
          label: "Lead",
          as: "staff"
        },
        {
          name: "sale",
          label: "Commercial",
          as: "staff"
        },
        {
          name: "dispatcher",
          label: "Répartiteur",
          as: "staff"
        },
        {
          name: "reloc",
          label: "Relocation",
          as: "staff"
        },
        {
          name: "alsender",
          label: "Dossier final",
          as: "staff"
        }
      ]
    };
  },
  methods: {
    async deleteProspect() {
      try {
        const resp = await fetchHil(`/prospects/${this.prospect._id}`, {
          method: "DELETE"
        });
        if (!resp.ok) {
          return alert("Une erreur a eu lieu");
        }
        this.$router.push("/prospects");
      } catch (e) {
        console.log(e);
        alert("Une erreur a eu lieu");
      }
    }
  },
  computed: {
    ...mapState("user", ["role"])
  }
};
</script>

<style scoped>
.no-clamp {
  -webkit-line-clamp: 1000 !important;
}

.fsz {
  font-size: 12px !important;
}

.general-hints {
  color: #555;
  margin-left: 30px;
  margin-bottom: 24px;
}
</style>
